import {Component} from "../Component";
import {element} from "../CustomElement";
import {inject} from "../../services/di";
import {UserAgentService} from "../../services/UserAgentService";
import {BranchService} from "../../services/BranchService";
import {ConfigService, DistributionMode} from "../../services/ConfigService";
import {StorageService} from "../../services/StorageService";
import {LocationService} from "../../services/LocationService";
import {isCrawler} from "../../utils/crawler";

import { i18n } from "../../i18n/I18n";

@element("desktop-banner")
export class DesktopBanner extends Component<{}, {}> {
	@inject config: ConfigService;
	@inject userAgent: UserAgentService;
	@inject branch: BranchService;
	@inject storageService: StorageService;
	@inject locationService: LocationService;


	whenWasHiddenName = "when-was-hidden-desktop-banner";

	refs: {
		number: HTMLInputElement,
	};

	state = {
		number: "",
		error: false,
		done: false,
		changed: false,
	};

	onAttach() {
		setTimeout(() => this.show(), 1500);
	}

	isBannerHidden() {
		if (isCrawler()) {
			return true;
		}
		if (this.userAgent.mobile || this.config.DISTRIBUTION_MODE !== DistributionMode.NONE) {
			return true;
		}
		const whenWasHidden = Cookies.get(this.whenWasHiddenName);

		if (whenWasHidden === null) {
			return false;
		}
		return Math.abs((new Date()).getTime() - parseInt(whenWasHidden)) <= 864e5;
	}

	render() {
		if (this.isBannerHidden()) {
			return null;
		}
		return (
			<div class="desktop-banner desktop-banner--hidden">
				{!this.state.done ? this.renderBody() : this.renderMessageSent()}
				{this.renderClose()}
			</div>
		);
	}

	renderBody = () => {
		return (
			<div class="desktop-banner__wrapper">
				<div class="desktop-banner__phone-img">
					<img
						alt=""
						src="https://f.wishabi.net/creative/Distribution/images/banner/desktop-banner-phone-new.png"
					/>
				</div>
				<div class="desktop-banner__main">
					<div class="desktop-banner__title">
						{i18n("desktop_banner_title")}
					</div>
					<div class="desktop-banner__body">
						{i18n("desktop_banner_body")}
					</div>
					<div class="desktop-banner__phone-number">
						<div class="desktop-banner__phone">
							<div class="desktop-banner__phone-prefix">
								+1
							</div>
							<input
								ref="number"
								type="text"
								class="desktop-banner__input"
								placeholder={i18n("desktop_banner_placeholder")}
								onInput={this.handleInputChange}
								value={this.state.number}
							/>
						</div>
						<button
							onClick={this.submit}
							class="desktop-banner__submit desktop-banner__submit--disabled"
						>
							{i18n("desktop_banner_submit")}
						</button>
					</div>
					{this.state.error && <div class="desktop-banner__error">
						Invalid number. Please check for mistakes and try again.
					</div>}
					<div class="desktop-banner__footer">
						{i18n("desktop_banner_footer")}{this.getPrivacyLink()}{i18n("desktop_banner_footer_2")}
					</div>
				</div>
				<div class="desktop-banner__qr-code">
					<img
						alt=""
						src="https://f.wishabi.net/creative/Distribution/images/banner/desktop-banner-qr-install-code.jpeg"
					/>
				</div>
			</div>
		);
	}

	renderClose = () => {
		return (
			<div
				class="desktop-banner__close"
				onClick={this.close.bind(this)}
			>
				<img
					alt=""
					src="https://f.wishabi.net/creative/Distribution/images/banner/close-icon.png"
				/>
			</div>
		);
	}

	renderMessageSent = () => {
		const mainClassAppendix = this.locationService.locale === "fr-ca" ? " french" : "";
		const mainClass = "desktop-banner__main desktop-banner__message" + mainClassAppendix;
		return (
			<div class="desktop-banner__wrapper">
				<div class={mainClass}>
					<div class="desktop-banner__title">
						{i18n("desktop-banner_success_title")}
					</div>
					<div class="desktop-banner__message-body">
						{i18n("desktop-banner_success_body", {
							number: this.state.number
						})}
					</div>
				</div>
			</div>
		);
	}

	parseNumber = (prepared: string) => {
		let result = "";
		for (let i = 0; i < prepared.length; i++) {
			if (i === 0) {
				result += "(";
			}
			if (i === 3) {
				result += ") ";
			}
			if (i === 6) {
				result += "-";
			}
			result += prepared[i];
		}
		return result;
	}

	handleInputChange = () => {
		const number = this.refs.number.value;
		const prepared = number.replace(/\D/g, "").slice(0, 10);
		if (this.isValid(prepared)) {
			this.enableSubmit();
		} else {
			this.disableSubmit();
		}

		this.state.number = this.parseNumber(prepared);
		// @ts-ignore
		document.getElementsByClassName("desktop-banner__input")[0].value = this.state.number;
	}

	hideInputPrefix = () => {
		this.state.changed = false;
		document
			.getElementsByClassName("desktop-banner__input")[0]
			.classList.remove("desktop-banner__input--typed");
		document
			.getElementsByClassName("desktop-banner__phone-prefix")[0]
			.classList.add("desktop-banner__phone-prefix--hidden");
	}

	showInputPrefix = () => {
		this.state.changed = true;
		document
			.getElementsByClassName("desktop-banner__input")[0]
			.classList.add("desktop-banner__input--typed");
		document
			.getElementsByClassName("desktop-banner__phone-prefix")[0]
			.classList.remove("desktop-banner__phone-prefix--hidden");
	}

	disableSubmit = () => {
		document
			.getElementsByClassName("desktop-banner__submit")[0]
			.classList.add("desktop-banner__submit--disabled");
	}

	enableSubmit = () => {
		document
			.getElementsByClassName("desktop-banner__submit")[0]
			.classList.remove("desktop-banner__submit--disabled");
	}

	showError = () => {
		this.state.error = true;
		document
			.getElementsByClassName("desktop-banner__footer")[0]
			.classList.add("desktop-banner__footer--hidden");
		document
			.getElementsByClassName("desktop-banner__phone")[0]
			.classList.add("desktop-banner__phone-number--error");
	}

	hideError = () => {
		this.state.error = false;
		document
			.getElementsByClassName("desktop-banner__footer")[0]
			.classList.remove("desktop-banner__footer--hidden");
		document
			.getElementsByClassName("desktop-banner__phone")[0]
			.classList.remove("desktop-banner__phone-number--error");
	}


	isValid = (number: string) => {
		return number.replace(/\D/g, "").length === 10;
	}


	submit = () => {
		if (!this.isValid(this.state.number)) {
			return;
		}
		this.hide();
		this.state.done = true;
		const number = `+1${this.state.number.replace(/\D/g, "")}`;
		setTimeout(() => {
			this.invalidate();
			this.show();
		}, 2000);
		try {
			this.branch.sendSMS(number);
		} catch (e) {
			console.log(e);
		}
	}

	show = () => {
		const el = 	document.getElementsByClassName("desktop-banner")[0];
		if (el) {
			el.classList.remove("desktop-banner--hidden");
		}
	}

	hide = () => {
		const el = 	document.getElementsByClassName("desktop-banner")[0];
		if (el) {
			el.classList.add("desktop-banner--hidden");
		}
	}

	close = () => {
		Cookies.set(this.whenWasHiddenName, (new Date()).getTime().toString(), {
			expires: 1,
			domain: this.config.getCookiesDomain()
		});
		this.hide();
		setTimeout(() => {
			const el = 	document.getElementsByClassName("desktop-banner")[0];
			if (el) {
				el.classList.add("desktop-banner--hidden-fully");
			}
		}, 2100);
	}

	getPrivacyLink = () => {
		return (
			<a target="_blank" href="https://corp.flipp.com/flipp/privacy">{i18n("desktop_banner_privacy_policy")}</a>
		);
	}
}
